'use strict';

var React = require('react'),
    ContextMenu = require('../molecules/ContextMenu'),
    ZineStore = require('../stores/ZineStore'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    ServiceTypes = require('../constants/ServiceTypes'),
    ShareZineLink = require('../atoms/ShareZineLink'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

var ZineShareContextMenu = React.createClass({
  mixins: [createStoreMixin(ZineStore), PureRenderMixin],

  propTypes: {
    zineSlug: React.PropTypes.string.isRequired,
    anchorRect: React.PropTypes.object.isRequired
  },

  getStateFromStores(props) {
    return {
      zine: ZineStore.get(props.zineSlug)
    };
  },

  componentWillReceiveProps(newProps) {
    if (newProps.zineSlug !== this.props.zineSlug) {
      this.setState(this.getStateFromStores(newProps));
    }
  },

  render() {
    var items = [
      ServiceTypes.FACEBOOK,
      ServiceTypes.TWITTER,
      ServiceTypes.GOOGLE
    ].map(this.renderMenuItem);

    return (
      <ContextMenu anchorRect={this.props.anchorRect}>
        {items}
      </ContextMenu>
    );
  },

  renderMenuItem(service) {
    var zine = this.state.zine;

    return (
      <ShareZineLink key={service}
                     service={service}
                     zine={zine}
                     context='ContextMenu'
                     underline='never'
                     propagateClick />
    );
  }
});

module.exports = ZineShareContextMenu;



/** WEBPACK FOOTER **
 ** ./contextMenus/ZineShareContextMenu.jsx
 **/